//上传文件
export const upload = "/app/common/upload";
//获取短信验证码
export const sendCode = "/app/login/smsCode";
//获取邮箱验证码
export const sendEmailCode = "/app/login/smsEmail";
//手机号预注册
export const mobilePreRegister = "/app/login/mobileLogin";
//邮箱预注册
export const emailPreRegister = "/app/login/emailLogin";
export const emailRegister = "/app/login/emailregister";
//获取职位
export const DictPosition = "/app/common/queryPosition";
//获取部门
export const DictOrg = "/app/common/queryOrg";
//获取称谓
export const DictGender = "/app/common/queryTitleType";
//观众信心添加
export const visitorInfoAdd = "/app/user/saveUserInfo/";
//观众问卷添加
export const visitorQuestionAdd = "/app/user/saveQuestion/";
//获取问卷调查
export const questionPage = "/app/common/queryUserQuestions";
//邮箱登录
export const emailLogin = "/app/login/emailLoginByToken";
//邮箱登录
export const emailLoginWithoutPassword = "/app/login/emailLoginWithoutPassword";
//手机号登录
export const mobileLogin = "/app/login/loginByToken";
//观众获取用户信息
export const vistorUserInfo = "/app/user";
//获取观众更多信息
export const vistorMoreUserInfo = "/app/user/getMoreUserInfo";
//获取用户填写的确认报表
export const reportAnswer = "/app/user/getAnswer";
//更新用户信息
export const updateUserInfo = "/app/user/modifyUserInfo";
//更新客户确认表
export const updateReport = "/app/user/editQuestion";
//观众中心=>邮件邀请好友
export const inviteEmailAdd = "/app/login/smsInviteEmail?email=";
//观众中心=>我的邮件邀请记录
export const inviteEmailList = "/app/user/getInviteEmailHistory";
//为他人注册
export const regOther = "/app/login/helpMobileReg";
//查询我为他人注册的列表
export const regOtherList = "/app/user/getHelpRegHistory";
//我的优惠券信息
export const myExchangeCouponPageList = "/app/user/myExchangeCouponPageList";
//展商手机号预注册
export const exRegisterPre = "/app/login/merchantMobileLogin";
//展商邮箱预注册
export const exRegisterEmailPre = "/app/login/merchantEmailLogin";
export const merchantApply = "/app/merchant/apply";
//展商中心=>添加公司信息
export const zsCompanyInfoAdd = "/app/merchant/saveOrUpdateCompanyProfiles";
//展商中心=>获取我的公司信息
export const zsCompanyInfo = "/app/merchant/getCompanyProfiles";
//展商中心=>获取我的展品信息
export const zsEntriesList = "/app/merchant/getMyEntriesList";
//展商中心=>添加我的展品信息
export const zsEntriesAdd = "/app/merchant/editOrAddMerchantEntries";
//展商中心=>删除展品信息
export const zsEnttiesDel = "/app/merchant/deleteEntriesBatch";
//展商中心=>获取我的宣传信息
export const zsPropagandaList = "/app/merchant/getMyPropagandaList";
//展商中心=>添加我的宣传信息
export const zsPropagandaAdd = "/app/merchant/editOrAddMtPropaganda";
//展商中心=>删除我的宣传信息
export const zsPropagandaDel = "/app/merchant/deletePropagandaBatch";
//展商中心=>获取我的发票信息
export const zsInvoieInfo = "/app/merchant/getMyInvoiceList";
//展商中心=>添加我的发票信息
export const zsInvoiceAdd = "/app/merchant/editOrAddInvoiceInfo";
//展商中心=>参展商服务手册列表
export const zsServiceList = "/app/merchant/getServiceList";
//展商中心=>参展商服务手册根据ID查询表单
export const zsServiceForm = "/app/merchant/getFormsById/";
//展商中心=>参展商服务手册上传文件
export const zsServiceFormFile = "/app/merchant/saveOrUpdateFileUploads";
//展商中心=>参展商服务手册上传表单答案
export const zsServiceFormAnswer = "/app/merchant/saveOrUpdateFileSubmissions";
//展商中心=>发布采购需求
export const zsPostAdd = "/app/posts/addPosts";
//展商中心=>我发布的采购需求
export const zsPostMine = "/app/posts/myList";
//展商中心=>采购需求详情
export const zsPostDetail = "/app/posts/queryPostsById";
//展商中心=>采购需求删除
export const zsPostDel = "/app/posts/deletePosts";
//查询全部的采购需求
export const allPosts = "/app/posts/getAllList";
// 查询推荐的采购需求
export const getRecommendAllList = "/app/posts/getRecommendAllList";

//-------app----info
//展商信息
export const getCompanyProfilesList = "/app/info/getCompanyProfilesList";
//展商详情
export const getCompanyProfiles = "/app/user/getCompanyProfiles/"; //拼接id
// 根据展商id查询展商下的展品
export const getMyEntriesList = "/app/user/getMyEntriesList/"; //拼接id
// 展商展品收藏
export const addCollection = "/app/user/addCollection";
//展品信息
export const getEntriesList = "/app/info/getEntriesList";
// 展品详情
export const getEntriesById = "/app/user/getEntries/";
//需求信息
export const getPostsAllList = "/app/info/getPostsAllList";
// 展品和展商的咨询
// 添加咨询/创建咨询主题
export const addConsultations = "/app/posts/addConsultations";
// 评论里回复评论
export const addMxComments = "/app/posts/addMxComments";
// 查询我的咨询
export const queryMyConsultationsPageList =
	"/app/posts/queryMyConsultationsPageList";
// 查询他人咨询我的
export const queryConsultationsMePageList =
	"/app/posts/queryConsultationsMePageList";
// 查询咨询详情
export const queryConsultationsDetail = "app/posts/queryConsultationsDetail/";
export const listMxCommentsByMainId = "/app/posts/listMxCommentsByMainId/";

// 展会动态
export const queryArticlePageList = "/app/info/queryArticlePageList"; // 通用查询文章接口
export const getFormsById = "/app/user/getFormsById"; // 查询行业动态表单应该填写的内容
export const saveReport = "/app/user/saveReport"; // 行业报名信息提交
export const queryArticleById = "/app/info/queryArticleById";

//收藏列表
export const collectList = "/app/posts/queryMyPageList";
//取消收藏
export const collectDel = "/app/user/deleteCollection/";
//订阅展讯
export const addExhibition = "/app/user/addExhibition";

// 会刊
export const queryMerchantArticlePageList =
	"/app/info/queryMerchantArticlePageList";
export const addMerchantArticle = "/app/info/addMerchantArticle";
export const deleteBatchMerchantArticle =
	"/app/info/deleteBatchMerchantArticle";
// 通过展商id查询会刊列表
export const queryMerchantArticlePageListById =
	"/app/info/queryMerchantArticlePageListById/";

// 展商中心首页下面列表
export const getNoCompleteServiceList =
	"/app/merchant/getNoCompleteServiceList";
// 热门视频直播
export const queryVideoImgPageList = "/app/info/queryVideoImgPageList";

// 我已参加的会议列表
export const myReportArticlePageList = "/app/user/myReportArticlePageList";
// 取消报名参加的会议
export const myReportCancelApply = "/app/user/cancelReport/";
// 全局查询
export const searchIndex = "/app/searchIndex/search";

//展商证列表
export const zszList = "/app/merchant/getCertificationApplyList";
//展商证新增
export const zszAdd = "/app/merchant/saveCertificationApply";
//展商证删除
export const zszDel = "/app/merchant/deleteCertificationApply/";
//展商证修改
export const zszEdit = "/app/merchant/updateCertificationApply";
// 广告添加
export const addAdvertising = "/app/merchant/addAdvertising";
// 广告列表
export const myAdvertisingPageList = "/app/merchant/myAdvertisingPageList";
export const adDefList = "/app/adv/list";
export const adRequest = "/app/adv/request";
export const submitAdList = "/app/adv/apply";

// 获取验证码
export const getCodeInfo = "/sys/randomImage";

//展商修改密码
export const zsChangePsw = "/app/login/password";

//会刊信息获取和提交
export const journalInfo = "/app/journal/info";

//产品分类代码
export const category = "/category/product/tree";

export const compnayJoinList = "/app/front/static/companiesJoins";
export const articleList = "/app/front/static/articles";

//展商中心获取广告类型
export const adType = '/app/adv/typeList'

//获取首页轮播图client值为pc或h5
export const banner = '/app/banner?client=pc'

//参展企业展示（首页底部轮播组图，根据type查询：1.数智赋能创新设备、2.辅助加工配套、3.绿色低碳解决方案、4.品质线缆线材、5.精准测控技术）
export const displayCompany = '/app/display/companies'

//根据code获取配置项
export const codeConfig = '/app/config/'

//获取联系人卡片信息(1.联系我们=>参展联络、2.联系我们=>参观联络/商贸配对、3.联系我们=>媒体联络、4.住宿、5.展位申请、
// 6.展商宣传申请、7.观众注册、8.参观团登记、9.会议活动=>线缆云会、10.会议活动=>境外展会)
export const linkage = '/app/linkage?position='

//获取交通方式
export const trafficOptions = '/app/traffic'

//获取住宿信息
export const hotelTable = '/app/hotel'

//参展流程
export const flowProcess = '/app/flow'

//直播列表
export const live = '/app/live'

//查询展会是否结束
export const isEnd = '/app/config/isEnd'

//查询观众历史基础信息
export const userInfoHistory = '/app/user/getUserinfoHistory/'

//查询观众历史问卷调查
export const questionHistory = '/app/user/getAnswerHistory/'


// 观众团成员添加
export const addGroupMember = "/groupmember/mtGroupMember/add";
// 观众团成员查询
export const getGroupMemberList = "/groupmember/mtGroupMember/list";
// 观众团成员删除
export const deleteGroupMember = "/groupmember/mtGroupMember/delete";
// 观众团成员编辑
export const editGroupMember = "/groupmember/mtGroupMember/edit";
// 获取观众团信息
export const getGroupInfo = "/group/mtGroup/list";
// 观众团信息修改
export const Groupedit = "/group/mtGroup/edit";
// 在 api.js 中添加以下接口

// 参观团通过contactid查询（使用现有接口，但需要正确配置参数）
export const getGroupListByContact = "/group/mtGroup/list";

// 观众团团员批量删除接口
export const deleteGroupMemberBatch = "/groupmember/mtGroupMember/deleteBatch";

// 聊天记录相关接口
// GET /chat/records 为公网读取（智能客服 Coze 站点管理页在用），仅保留 pageSize 上限；
// GET /chat/records/list 为管理端读取，需要登录态 + chat:record:list 权限。
export const chatRecordList = "/chat/records"; // 分页查询聊天记录（GET，公网，Coze 在用）
export const chatRecordListAuth = "/chat/records/list"; // 分页查询聊天记录（GET，需登录 + chat:record:list 权限）
export const chatRecordAdd = "/chat/records"; // 新增聊天记录（POST，公网匿名写入，供智能客服调用）

// 知识库相关接口
export const knowledgeActiveList = "/knowledge/active"; // 查询启用的知识库列表（GET）
export const knowledgeAdd = "/knowledge"; // 新增知识库条目（POST）
export const knowledgeUpdate = "/knowledge"; // 更新知识库条目（PUT）
export const knowledgeDelete = "/knowledge"; // 删除知识库条目（DELETE），需拼接 /{id}

// 安全日志相关接口
export const securityLogList = "/security/logs"; // 分页查询安全日志（GET）
export const securityLogAdd = "/security/logs"; // 新增安全日志（POST）

// 观众团团员通过id查询
export const getGroupMemberById = "/groupmember/mtGroupMember/queryById";

// 批量导入团员（通过Excel）
export const batchAddGroupMember = "/groupmember/mtGroupMember/importExcel";



// 参观团信息修改
export const updateGroupInfo = "/group/mtGroup/edit";

// 参观团通过id查询详细信息
export const getGroupById = "/group/mtGroup/queryById";

// 邮件发送接口
export const sendEmail = "/app/email/send";